import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./Pill.css";

const Pill = ({ friendlyName, linkUrl, extraClassName }) => (
  <li className={classnames(styles.pillWrapper, extraClassName)}>
    <a href={linkUrl} className={styles.pill}>
      {friendlyName}
    </a>
  </li>
);

Pill.propTypes = {
  friendlyName: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  extraClassName: PropTypes.string
};

export default Pill;
